import { render, staticRenderFns } from "./buy_success1.vue?vue&type=template&id=f67f26b2&scoped=true&"
import script from "./buy_success1.vue?vue&type=script&lang=js&"
export * from "./buy_success1.vue?vue&type=script&lang=js&"
import style0 from "./buy_success1.vue?vue&type=style&index=0&id=f67f26b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67f26b2",
  null
  
)

export default component.exports